<template>
  <div class="panel-widgets">
    <b-row>
      <b-col>
        <b-collapse id="collapse-4" v-model="visible" class="mt-2 row">
          <denominaciones-con-excedentes></denominaciones-con-excedentes>
          <conteos></conteos>
          <saldos-actuales-por-delegacion></saldos-actuales-por-delegacion>
        </b-collapse>

        <div class="toggle-separator">
          <b-button
            size="lg"
            pill
            variant="outline-secondary"
            class="toggle-btn mx-auto d-block active"
            :class="visible ? null : 'collapsed'"
            :aria-expanded="visible ? 'true' : 'false'"
            aria-controls="collapse-4"
            @click="visible = !visible"
          >
            <b-icon :icon="visible ? 'chevron-up' : 'chevron-down'" aria-label="Help"></b-icon>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Conteos from "@/components/common/widgets/Conteos.vue";
import SaldosPorDivisa from "@/components/common/widgets/SaldosPorDivisa.vue";
import OfertasDemandas from "@/components/common/widgets/OfertasDemandas.vue";
import DenominacionesConExcedentes from "@/components/common/widgets/DenominacionesConExcedentes.vue";
import SaldosActualesPorDelegacion from "@/components/common/widgets/saldosActualesPorDelegacion.vue";

@Component({
  name: "panel-widgets",
  components: {
    SaldosActualesPorDelegacion,
    DenominacionesConExcedentes,
    OfertasDemandas,
    SaldosPorDivisa,
    Conteos,
  },
})
export default class PanelWidgets extends Vue {
  public visible = false;

  constructor() {
    super();
  }
}
</script>

<style lang="scss" scoped>
.panel-widgets {
  padding: 14px 9px;
}

.toggle-separator {
  border-top: none;
  border-bottom: solid 1px #e9e9e9;
}

.toggle-btn {
  width: 40px;
  height: 40px;
  padding: 5px 5px;
  margin-bottom: -20px;
}

.card {
  border: none;
  background-color: transparent;
  box-shadow: none;
}
</style>
